module.exports = __webpack_public_path__ + "img/mobile-50.b1ce60d8.png";